import {safeText} from "../../js/util/CommonUtils.js";
import StructurePopupCmp from "../StructurePopup/StructurePopupCmp.js";
import EventDialogCmp from "../EventDialog/EventDialogCmp.js";
import {getOpenInNewIcon} from "../../js/util/IconUtils.js";

export class TableHtml {
    /** @type {HTMLElement} */
    #parent;
    /** @type {HTMLElement} */
    #table;
    /** @type {HTMLElement} */
    #tableBody;
    TABLE_ROW_CLASS = 'page-table__row';

    /** @param {HTMLElement} parentNode */
    init(parentNode) {
        this.#parent = parentNode;
    }

    show() {
        const pageTable = this.#parent.querySelector('.page-table');
        if (pageTable)
            pageTable.remove()
        this.#parent.insertAdjacentHTML('beforeend', this.#tableTemplate());
        this.#table = this.#parent.lastElementChild;
        this.#tableBody = this.#table.querySelector('.page-table__body');
    }

    clearRows() {
        const rows = this.#tableBody.getElementsByClassName(this.TABLE_ROW_CLASS);
        while (rows.length > 0)
            rows[0].remove();
    }

    /** @param {MoleculeEvent[]} rows */
    addRows(rows) {
        for (const row of rows) {
            this.#tableBody.insertAdjacentHTML('beforeend', this.#rowTemplate(row));
            /** @type {Element} */
            const imgElement = this.#tableBody.lastElementChild.querySelector("img");
            imgElement.addEventListener("mouseover", () => {
                if (!imgElement.structurePopup) {
                    const p = new StructurePopupCmp();
                    imgElement.structurePopup = p;// storing it inside element so that we know if we already created it
                    p.init(imgElement);
                    p.show(row.structureRef);
                }
            });
            imgElement.addEventListener("mouseout", () => {
                imgElement.structurePopup.remove();
                imgElement.structurePopup = null;
            });
            this.#tableBody.lastElementChild.addEventListener('click', this.#onRowClick.bind(this, row))
        }
    }

    /**
     * @param {MoleculeEvent} mEvt
     * @param evt
     */
    #onRowClick(mEvt, evt){
        // Do not open dialog if click on link
        if(evt.target.closest('.page-table__cell-with-link'))
            return

        // If user opens dialog by click on image, first the mouseover event is triggered.
        // And we can see the image popup below the dialog, so we create "mouseout" event to close the dialog
        const imgEl = evt.target.closest('img');
        if (imgEl)
            imgEl.dispatchEvent(new MouseEvent("mouseout"));

        const dialog = new EventDialogCmp();
        dialog.show(mEvt)
    }

    /**
     * @param {MoleculeEvent} e
     * @returns {string} HTML
     */
    #rowTemplate(e) {
        const contextShort = (e.entity || e.context|| "").substring(0, 10);
        const entityName = `${safeText(e.originatingSystem)}: ${safeText(contextShort)}`;
        return `<li class="page-table__row"">
					<span class="page-table__cell"><img height="40" src="${safeText(e.structureRef)}" alt="structure"></span>
					<span class="page-table__cell">${safeText(e.scientist) || ""}</span>
					<span class="page-table__cell">${safeText(e.eventName) || ""}</span>
					<span class="page-table__cell page-table__cell-with-link"><a href="${safeText(e.detailsUiUrl)}" target="_blank" class="page-table__external-link"><span class="page-table__link-underlined">${entityName}</span> ${getOpenInNewIcon()}</a></span>
					<span class="page-table__cell">${e.happenedTimeFormatted}</span>
  				</li>`;
    }

    /** @returns {string} */
    #tableTemplate() {
        return `<section class="page-table">
                  <div class="page-table__row--header page-table__row">
                    <button class="page-table__header-cell">Structure</button>
                    <button class="page-table__header-cell">Scientist</button>
                    <button class="page-table__header-cell">Event</button>
                    <button class="page-table__header-cell">Origin</button>
                    <button class="page-table__header-cell">Happened</button>
                  </div>
                  <div class="page-table__body"></div>
                </section>`;
    }
}